import { RefundInitiationFilterPage } from "./refundInitiationFilter/RefundInitiationFilterPage";
import { RefundInitiationTablePage } from "./refundInitiationTable/RefundInitiationTablePage";
import classes from "./refundInitiationListPage.module.css";


export const RefundInitiationListPage = () => {
  return (
    <div className={classes.box}>
      <RefundInitiationFilterPage />
      <RefundInitiationTablePage />
    </div>
  );
};
